<template>
  <div>
    <div class="bg-forest">
      <div class="container">
        <div class="text-center" v-if="isLoading">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <studentCard :user="user"></studentCard>
        </div>
      </div>
    </div>
    <hr class="space space-sm">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StudentCard from '../Student/Includes/StudentCard'

export default {
  components: {
    studentCard: StudentCard
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isLoading: state => state.auth.loading
    })
  },
  methods: {
    openEditModal () {
      this.editGroup = null
      setTimeout(() => {
        this.$refs.modal.toggleModal()
      }, 100)
    },
    update () {
      this.$store.dispatch('GET_USER')
      this.$refs.modal.hideModal()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('SET_LOADING', false)

    setTimeout(() => {
      this.show = false
    }, 2000)
  },
  created () {
    this.$store.dispatch('SET_LOADING', true)
    this.$store.dispatch('GET_USER')
  }
}
</script>

<style>

</style>
